import { Button, message, Modal, Upload } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { useEffect, useState } from 'react'

import { upload } from '@testing-library/user-event/dist/upload'
import { uploadImg } from '../../../../api/api'
import { getBase64 } from '../../../../utils/getbase64'
import { cloneElement } from 'react'
import handleFileInUploading from '../../../../utils/cos'
import handleFileInCompressUploading from '../../../../utils/cos_compress'

const UploadHouseFirstImg = (props) => {
  const [thumbUrl, setThumbUrl] = useState()
  //向父组件传值 deliverUrl
  const { deliverUrl, image } = props
  // console.log(image);
  const [fileList, setFileList] = useState(
    image === ''
      ? []
      : [
          {
            uid: '-1',
            name: '房源首图.png',
            status: 'done',
            url: image,
          },
        ]
  )

  //图片预览
  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewImage, setPreviewImage] = useState('')
  const [previewTitle, setPreviewTitle] = useState('')
  const [isRemove, setIsRemove] = useState(false)
  const myUpload = (file) => {
    const afterUpload = (origin, thumbnail, file) => {
      setIsRemove(false)
      const aporigin =
        'https://' + origin.replace('cos.accelerate', 'cos-website.ap-shanghai')
      const apthumbnail =
        'https://' +
        thumbnail.replace('cos.accelerate', 'cos-website.ap-shanghai')
      setFileList([
        {
          ...file,
          name: '房源首图',
          url: aporigin,
          status: 'done',
        },
      ])
      deliverUrl({ thumbnail: apthumbnail, origin: aporigin })

      if ((aporigin ?? false) && aporigin !== '') {
        message.success('图片上传成功！')
      }
    }
    handleFileInCompressUploading(file.file, afterUpload)
  }

  const handleChange = ({ file, fileList }) => {
    console.log('handleCHange', file)
    if (file.status === 'uploading') {
      setFileList([
        {
          ...file,
          url: thumbUrl,
          status: 'uploading',
        },
      ])
    }

    if (file.status === 'removed') {
      setFileList([])
    }
  }

  function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
      message.error('只能上传JPG或PNG文件!')
      return false
    }
    const isLt100M = file.size / 1024 / 1024 < 100
    if (!isLt100M) {
      message.error('图片大小需小于10MB!')
      return false
    }

    return isJpgOrPng && isLt100M
  }

  // 方法：图片预览
  const handlePreview = async (file) => {
    if ((!file.url && !file.preview) ?? true) {
      file.preview = await getBase64(file.originFileObj)
    }
    // console.log('smyhvae handlePreview:' + JSON.stringify(file))
    setPreviewImage(file.url || file.preview)
    setPreviewOpen(true)
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf('/') + 1)
    )
  }

  const handleCancel = () => setPreviewOpen(false)

  // const myPreview = (file) => {
  //   // console.log(file,"preview");
  //   let formData = new FormData()
  //   formData.append('file', file)
  //   // console.log(formData)

  //  return uploadImg(formData).catch((err) => {
  //       message.error(`图片上传超时！`)
  //       setFileList([])
  //     })
  //     .then((res) => {
  //       const info = res.data.data
  //       setThumbUrl(res.data.data.thumbnail)
  //       setIsRemove(false)
  //       deliverUrl({
  //         thumbnail: info.thumbnail,
  //         origin: info.origin,
  //       })
  //       return new Promise ((resolve,reject) => {
  //         resolve(res)
  //       })
  //     }).then(res => {
  //       // console.log(res.data.data.thumbnail);
  //       return res.data.data.thumbnail
  //     })

  // }

  return (
    // <Upload name="logo" customRequest={myUpload} listType="picture">
    //   <Button icon={<UploadOutlined />}>上传图片</Button>
    // </Upload>
    <>
      <Upload
        beforeUpload={beforeUpload}
        onChange={handleChange}
        customRequest={myUpload}
        fileList={fileList}
        onPreview={handlePreview}
        listType="picture"
        // previewFile={myPreview}
        // onRemove={handleRemove}
      >
        {fileList.length >= 1 ? null : (
          <Button icon={<UploadOutlined />}>上传图片</Button>
        )}
      </Upload>
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img
          alt="example"
          style={{
            width: '100%',
          }}
          src={previewImage}
        />
      </Modal>
    </>
  )
}

export default UploadHouseFirstImg
